import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import CompleteReport from './App.vue'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'

Bugsnag.start({
  apiKey: 'e59390fc1d73d0e691454a6b6ce00f28',
  releaseStage: import.meta.env.MODE,
  plugins: [new BugsnagPluginVue()],
  onError: function (event) {
    event.context = 'Lifestyle Web - Complete Report'
  }
})

BugsnagPerformance.start({ apiKey: 'e59390fc1d73d0e691454a6b6ce00f28' })

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(CompleteReport)
const bugsnagVue = Bugsnag.getPlugin('vue')

app.use(pinia)
app.use(bugsnagVue)
app.mount('#complete-report-container')